import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface TableSettingState {
    pagination: {
        pageSize: number;
    };
    groupBy: string;
}

const initialState: TableSettingState = {
    pagination: {
        pageSize: 10
    },
    groupBy: 'Product'
};

export const tableSettingSlice = createSlice({
    name: 'tableSetting',
    initialState,
    reducers: {
        setTableSetting: (state, action: PayloadAction<TableSettingState['pagination']>) => {
            state.pagination = action.payload;
        },
        setTablePagination: (state, action: PayloadAction<number>) => {
            state.pagination.pageSize = action.payload;
        },
        setGroupByValue: (state, action: PayloadAction<string>) => {
            state.groupBy = action.payload;
        }
    }
});

export const { setTableSetting, setTablePagination, setGroupByValue } = tableSettingSlice.actions;

export const selectTableSetting = (state: RootState) => state.tableSetting;
export const selectTablePagination = (state: RootState) => state.tableSetting.pagination;
export const selectedGroupBy = (state: RootState) => state.tableSetting.groupBy;

export default tableSettingSlice.reducer;
